import React, { useContext, useEffect, useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import UserContext, { useUser } from '../../data/user'
const Logout = () => {
    const [{ api, activeUser }] = useUser()
    useEffect(() => {
        if (activeUser) {
            api.logout()
        }
    }, [activeUser])
    return null
}

export default Logout
